"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
function getEffectiveTitle(pageTitle, brandTitle) {
    return compact_1.default([pageTitle, brandTitle]).join(" - ");
}
/**
 * @internal
 */
var DocumentHeader = function (props) {
    var _a = props.pageTitle, pageTitle = _a === void 0 ? "" : _a, _b = props.brandTitle, brandTitle = _b === void 0 ? "" : _b, _c = props.appleTouchIconUrl, appleTouchIconUrl = _c === void 0 ? "" : _c, _d = props.faviconUrl, faviconUrl = _d === void 0 ? "" : _d;
    return (react_1.default.createElement(react_helmet_1.Helmet, null,
        react_1.default.createElement("title", null, getEffectiveTitle(pageTitle, brandTitle)),
        react_1.default.createElement("link", { rel: "apple-touch-icon", type: "image/png", href: appleTouchIconUrl }),
        react_1.default.createElement("link", { rel: "shortcut icon", type: "image/x-icon", href: faviconUrl })));
};
exports.default = DocumentHeader;
//# sourceMappingURL=DocumentHeader.js.map